import React, { useState } from 'react';
import Modal from './Modal';
import versionInfo from '../../src/version.json';

const AboutUs = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="text-gray-300 hover:text-orange-400 px-2 md:px-3 py-1.5 md:py-2 text-base md:text-lg transition-colors font-mono"
      >
        About
      </button>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="About Innominate Appraisal"
      >
              <div className="space-y-4 text-sm md:text-base">
                  <p>
                      To Innominate: A Shining Star in EVE Online
                  </p>
                  <p>
                      Innominate's remarkable legacy illuminates the vast expanse of EVE Online. As a visionary Director, he spearheaded KarmaFleet and CSM with unwavering dedication, brilliance and compassionate leadership.
                  </p>
                  <p>
                      In a universe where trust is rare and betrayal is often celebrated, Innominate's steadfast dedication to his corp and allies made him a legend. His contributions to the EVE community transcended the game, leaving behind such a legacy.
                  </p>
                  <p>
                      His selflessness inspired growth, fostering unity and camaraderie. Innominate's generosity and unwavering optimism touched countless lives.
                  </p>
                  <p>
                      Though his star may have dimmed too soon, its radiance forever brightens our memories. His impact on our community remains profound.
                  </p>
                  <p>
                      Rest in peace, Innominate. Your legend endures.
                  </p>

          
          <p className="text-orange-400 font-semibold">About the APP:</p>
          
          <div className="space-y-2 pl-6">
            <div className="flex items-start gap-2">
              <span className="text-orange-400">•</span>
              <span>Work in Progress, Expect bugs.</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-orange-400">•</span>
              <span>API Coming Soon...LIES, ITS ALREADY ONLINE</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-orange-400">•</span>
              <span>Shopping List, tells you where is best to buy what</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-orange-400">•</span>
              <span>More Bugs...</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-orange-400">•</span>
              <span>Powerfull Reprocessing Tool with complete Settings </span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-orange-400">•</span>
              <span>You don't have to type the exact item names.</span>
            </div>            
            <div className="flex items-start gap-2">
              <span className="text-orange-400">•</span>
              <span>More Markets coming...</span>
            </div>
          </div>
          <p className="text-orange-400 font-semibold">Contacts:</p>
          <div className="flex items-center justify-center gap-4 ">
            <a href="https://evewho.com/corporation/98547848">
              <img className='size-16' src="https://images.evetech.net/corporations/98547848/logo" alt="Innominate Appraisal" />
            </a>
            <a href="https://discord.gg/PsSqSGtjBp">
              <img className='discord' src={process.env.PUBLIC_URL + '/discord.png'} alt="Innominate Appraisal" />
            </a>
            {/* <img className='discord' src={process.env.PUBLIC_URL + '/discord.png'} alt="My Image" /> */}
          </div>

          <div className="mt-6 pt-4 border-t border-gray-700">
            <p className="text-gray-400 text-xs md:text-sm text-center">
                immortalizing his name through every appraisal.
            </p>
            <p className="text-gray-400 text-sm text-center">
                Version {versionInfo.version}-{versionInfo.stage} ({versionInfo.commitId}) | © 2024 Innominate Appraisal
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AboutUs;
